import { FC } from 'react';
import { PackageDetails } from 'ts/package/interfaces/PackageDetails';
import { useTranslation } from 'react-i18next';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface HotelFacilitiesProps {
  dealModel: PackageDetails;
}

const HotelFacilities: FC<HotelFacilitiesProps> = ({ dealModel: { info } }) => {
  const [t] = useTranslation();
  const hotelFacilities = info.hotelFacilities?.filter((fac) => fac.facilityType === 'Hotel') || [];
  const roomFacilities = info.hotelFacilities?.filter((fac) => fac.facilityType === 'Room') || [];

  return (
    <div className="flex-between">
      {!!info && !info.hotelFacilities?.length && (
        <div className="no-entries">{t('no_entries')}</div>
      )}
      {!!hotelFacilities.length && (
        <div className="package-facility">
          <div className="text-info mb-10">{t('hotel.hotel_facilities')}</div>
          <div className="package-facility-list text-sm">
            {hotelFacilities.map((facility, index) => (
              <div key={index} className="package-facility-item">
                <div className="package-facility-img mr-5">
                  <img src={facility.url} alt={facility.facilityCode} />
                </div>
                {facility.facilityTitle}
              </div>
            ))}
          </div>
        </div>
      )}
      {!!roomFacilities.length && (
        <div className="package-facility">
          <div className="text-info mb-10">{t('hotel.room_facilities')}</div>
          <div className="package-facility-list text-sm">
            {roomFacilities.map((facility, index) => (
              <div key={index} className="package-facility-item">
                <div className="package-facility-img mr-5">
                  <img src={facility.url} alt={facility.facilityCode} />
                </div>
                {facility.facilityTitle}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(HotelFacilities, 'HotelFacilities');
